import React, {useState, useEffect, createRef} from 'react';
import { OwnerListProps } from '../../../types/sidePanel.types';
import * as SidePanelAction from '../../../actions/sidePanel.actions';
import TextField from '../../../../styled-base/input/text';
import {useOnClickOutside} from '../../../../hooks/useOnClickOutside';
import BoardService from '../../../services/board.service';
import {searchMatchedTextValue} from '../../../../utils/common';

const OwnerListComp = (props: OwnerListProps) => {
  const inputRef = createRef();
  const service = new BoardService();
  const {aiId, teamId, tagId, srcVal, columnId} = props;
  const [aiAssigniListFull, setAiAssigniListFull] = useState<any>([]);
  const [aiAssigniList, setAiAssigniList] = useState<any>([]);
  const [searchText, setSearchText] = useState<string>('');

  const isAiAutomation: boolean = (srcVal == 'automation') ? true : false;
  const [wrapperRef] = useOnClickOutside(() => {
    hidePopup();
  });

  const hidePopup = () => {
     if (typeof props.hideShowListPopup === 'function') {
      props.hideShowListPopup();
  }
  }

  useEffect(() => {
      setTimeout(() => {
        let e: any = document.querySelector('#wsBoardAssigniSearch');
        if (e) {
          e.focus();
        }
      }, 0);
  }, []);

  useEffect(() => {
    if (isAiAutomation) {
      service.getTeamMembersForAiAutomation({automation: true, teamId, tagId})
          .then(response => {
            const assigniL = response.data.response ?? [];
            setAiAssigniListFull(assigniL);
            setAiAssigniList(assigniL);
          });
    }
  }, [isAiAutomation]);

  const getViewAssigniList = (term: string) => {
    const params: any = {};

    if (tagId) params.tagId = tagId;

    params.term = term.toLowerCase();

    service.getOrgUsers(params)
      .then(response => {
        const viewAssigneesList = response.data ?? [];

        if (searchText) {
          setAiAssigniList(viewAssigneesList);
        }
      })
  }

  const searchAutomationData = (s: string) => {
    const searchList = aiAssigniListFull.filter((item: any) => {
      if (s) {
        const itemFirstName = item.user_name.toLowerCase();
        return searchMatchedTextValue(itemFirstName, searchText);
      }
      return true;
    });
    setAiAssigniList(searchList);
  }

  const searchAssigni = (e: any) => {
    let v = e.target.value;
    setSearchText(v);
    if (v && v !== "undefined" && v.length > 0) {
      if (isAiAutomation) {
        searchAutomationData(v);
      }
      else {
        getViewAssigniList(v);
      }
    } else {
      setAiAssigniList([]);
    }
  }

  const onChangeOwner = (item: { wsAccess?: string; id: any; name: any; lastName: any; pic?: any; user_id?: any; firstname?: any }) => {
    if (srcVal == "act" && aiId) {
      hidePopup();
      let private_req = "";
      if (item.wsAccess == "yes") {
        private_req = "no";
        props.dispatch(SidePanelAction.boardAiOwnerChange(aiId, item.id, item.name, item.lastName, item.pic, columnId));
      } else {
        private_req = "yes";
        props.dispatch(SidePanelAction.boardAiDelete(aiId, columnId));
      }
      service.updateAiOwner({
          assign: item.id,
          act_id: aiId,
          wsBoardView: true,
          private_req
      })
      .then(response => {
          if (typeof props.updateLoop === 'function') {
              service.getAiLoopMembers({aiId})
                .then(resp => {
                  const {status, loopMembers} = resp.data;
                  if (status == "success") {
                    props.updateLoop(loopMembers);
                  }
                })
          }
          props.dispatch(SidePanelAction.boardAiOwnerChange(
            aiId,
            item.id,
            item.name,
            item.lastName,
            (response as any).data.userPic,
            columnId
          ));
      })
    } else if (srcVal == "automation") {
      props.saveTitleAndValue(
        "ownerTitle",
        item.firstname,
        "ownerVal",
        item.user_id
      );
    } else if (srcVal == "automationWs") {
      props.savewsTitleAndwsValue(
        "wsownerTitle",
        item.name,
        "wsownerVal",
        item.id
      );
    }
  }

    const autoOwnenrClass =
      srcVal == "automation" || srcVal == "automationWs"
        ? "autoOwnerlistdiv"
        : "wsBoardOwnerListDiv";
    const aiAutoAssiginilist =
    srcVal == "automation" || srcVal == "automationWs"
        ? "aiAutoOwnerlistdiv"
        : "";

    return (
      <div className={`wsBoardOwnerListWrapperDiv ownerlistcomp-wrapper ${autoOwnenrClass}`} ref={wrapperRef}>
        <TextField
            classes="wsBoardAssigniSearch gbl-text-entry"
            inputProps={{
              id: 'wsBoardAssigniSearch',
              value: searchText,
              autoComplete: 'off',
              style: {width: '90%', height: '30px'}
            }}
            onChangeText={searchAssigni}
        />
        <div className={aiAutoAssiginilist}>
          {aiAssigniList.length
            ? aiAssigniList.map((item: any, index: any) => (
              <div
                key={`owner_${item.id}`}
                className="wsBoardUser clickable"
                onClick={() => onChangeOwner(item)}
              >
                {isAiAutomation ?`${item.firstname} ${item.lastname}` : `${item.name} ${item.lastName}`}
              </div>
            ))
            : ""}
        </div>
      </div>
    )
  }
export default OwnerListComp;
